import { CodetableTranslation } from 'app/area/codetable/constants';
import { routeConstants } from 'app/routes/route-constants';
import * as React from 'react';
import { Link } from 'react-router-dom';

export interface SearchButtonProps {
  codetableId: number;
  fetchingCodetableId: number;
  canCreate: boolean;
  breadcrumbs: number[];
  translation: CodetableTranslation;
}

export const SearchButton = ({ codetableId, fetchingCodetableId, canCreate, breadcrumbs, translation }: SearchButtonProps) =>
  codetableId === fetchingCodetableId && canCreate && <Link
    id={'codetable-list-link-create-button'}
    to={routeConstants.codetableAdministrationAddCodeFor(breadcrumbs)}
    className="btn btn-primary">
    {translation.add_new}
  </Link>;
